import {
  IntegrationCategories,
  IntegrationSyncMethod,
  type Integration,
} from '../IntegrationsList/IntegrationCard/utils';

export const hasAutomaticSync = (integration: Integration) => {
  return (
    integration.syncMethod === IntegrationSyncMethod.AutoSync ||
    integration.syncMethod === IntegrationSyncMethod.AutoSyncAndFile
  );
};

export const hasCustomFileImport = (integration: Integration) => {
  return (
    integration.syncMethod === IntegrationSyncMethod.CustomFile ||
    integration.syncMethod === IntegrationSyncMethod.AutoSyncAndFile
  );
};

export const isExchangeOrWallet = (integration: Integration) => {
  return (
    integration.category === IntegrationCategories.wallet ||
    integration.category === IntegrationCategories.exchange
  );
};

export const isBlockchain = (integration: Integration) => {
  return integration.category === IntegrationCategories.blockchain;
};

const getInstructionsHeadingExchangeOrWallet = (integration: Integration) => {
  const importStatement = hasAutomaticSync(integration)
    ? `Connecting your ${integration.name} account`
    : `Importing your ${integration.name} transactions`;
  return `${importStatement} to CoinTracker`;
};

const getInstructionsHeadingBlockchain = (integration: Integration) => {
  return `Connecting your ${integration.name} wallet to CoinTracker`;
};

export const getInstructionsHeading = (integration: Integration) => {
  if (isExchangeOrWallet(integration)) {
    return getInstructionsHeadingExchangeOrWallet(integration);
  }
  if (isBlockchain(integration)) {
    return getInstructionsHeadingBlockchain(integration);
  }
};

const getExchangeOrWalletButtonRedirectLink = (integration: Integration) => {
  return `/add_wallet?t=${integration.slug}`;
};

const getBlockchainButtonRedirectLink = (integration: Integration) => {
  if (integration.supportsHdWallet) {
    return '/add_wallet';
  } else {
    return '/add_wallet?t=public';
  }
};

export const getButtonRedirectLink = (integration: Integration) => {
  if (isExchangeOrWallet(integration)) {
    return getExchangeOrWalletButtonRedirectLink(integration);
  } else if (isBlockchain(integration)) {
    return getBlockchainButtonRedirectLink(integration);
  }
};
